import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config/config.service';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';
import { HelperService } from 'src/app/shared/helpers/helper.service';

@Component({
  selector: 'app-website-use',
  templateUrl: './website-use.component.html',
  styleUrls: ['./website-use.component.scss']
})
export class WebsiteUseComponent implements OnInit {

  public companyPhoneNumber: string;
  public useRebrandedLayout: boolean;

  constructor(public helperService: HelperService, private configService: ConfigService, private featureFlagService: FeatureFlagsService) {
    this.companyPhoneNumber = this.configService.getTextFromKey('company-phone-number');
    this.useRebrandedLayout = this.featureFlagService.isEnabled('useRebrandedLayout');
  }

  ngOnInit(): void {}
}
